export const tasks = [
  { title: "Remove rover from crater", points: 1 },
  {
    title: "Remove samples from crater",
    points: "1 per sample",
    isDynamic: true,
  },
  {
    title: "Sample placed on Lab Tile",
    points: "1 per sample",
    isDynamic: true,
  },
  {
    title: "Sample placed on top of the Lab",
    points: "2 per sample",
    isDynamic: true,
  },
  {
    title: "Sample placed on top of the Lab on the matching color square",
    points: "3 per sample",
    isDynamic: true,
  },
  { title: "Tilt the solar panel down", points: 1 },
  { title: "Clear the debris from the landing site", points: 1 },
  { title: "Place the helicopter by hand on the landing site", points: 1 },
  { title: "Lift the Rocket Ship", points: 1 },
  {
    title: "Release a Fuel Cell from the cradle",
    points: "1 per Fuel Cell",
    isDynamic: true,
  },
  { title: "Deliver a Fuel Cell to the Rocket Ship", points: 1 },
  { title: "Deliver a Fuel Cell to the Landing Site", points: 1 },
  { title: "End with the robot touching the red Tile", points: 1 },
];
